// local storage
export function getLocalValue<T>(key: string, defaultValue: T | null = null): T | null {
    if (typeof window === undefined || typeof window === "undefined") return defaultValue;
    try {
        const item: string | null = window.localStorage.getItem(key);
        const tItem: T | null = JSON.parse(item ?? "null");
        if (tItem === null) return defaultValue;
        return tItem;
    } catch (error) {
        return defaultValue;
    }
}

export function saveLocalValue(key: string, value: any): void {
    window.localStorage.setItem(key, JSON.stringify(value));
}

export function removeLocalValue(key: string) {
    window.localStorage.removeItem(key);
}

// session storage
export function getSessionValue<T>(key: string, defaultValue: T | null = null): T | null {
    if (typeof window === undefined || typeof window === "undefined") return defaultValue;
    try {
        const item: string | null = window.sessionStorage.getItem(key);
        const tItem: T | null = JSON.parse(item ?? "null");
        if (tItem === null) return defaultValue;
        return tItem;
    } catch (error) {
        return defaultValue;
    }
}

export function saveSessionValue(key: string, value: any): void {
    window.sessionStorage.setItem(key, JSON.stringify(value));
}

export function removeSessionValue(key: string) {
    window.sessionStorage.removeItem(key);
}
